import React from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { testIDs } from "../../../end-to-end-tests/constants/testIDs";
import { AppDispatch } from "../../app/types";
import { getPageTitle } from "../../shared/sessionUtility";
import DataTransferExportPanel from "./DataTransferExportPanel";
import DataTransferImportPanel from "./DataTransferImportPanel";
import TransferHistoryGrid from "./TransferHistoryGrid";
import "./dataTransfer.css";

const INSTRUCTIONS_URL =
    "https://help.avalara.com/0021_Avalara_CertCapture/All_about_CertCapture/Transfer_data_between_CertCapture_accounts";

/**
 * Transfer data between accounts. Access (internal users on a Premium subscription) is enforced
 * by the route's accessConfig. Shows the heading, instructions note, the export and import panels
 * and the transfer history grid.
 */
const DataTransferPage = (): React.ReactElement => {
    const dispatch = useDispatch<AppDispatch>();

    return (
        <>
            <Helmet>
                <title>{dispatch(getPageTitle("Data Transfer"))}</title>
            </Helmet>
            <div>
                <h1
                    className="margin-top-none margin-bottom-none"
                    data-testid={testIDs.dataTransfer.heading}>
                    Transfer data between accounts
                </h1>
                <p
                    className="margin-bottom-xl data-transfer-note"
                    data-testid={testIDs.dataTransfer.importantNote}>
                    <strong>Important:</strong> To prevent unintentional data loss, please read the{" "}
                    <a
                        href={INSTRUCTIONS_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid={testIDs.dataTransfer.instructionsLink}>
                        instructions for using this feature
                    </a>{" "}
                    before you proceed.
                </p>
                <DataTransferExportPanel />
                <DataTransferImportPanel />
                <TransferHistoryGrid />
            </div>
        </>
    );
};

export default DataTransferPage;
